import { useState } from 'react'
import { tryBuildQuillDelta } from './util'
import { QuillRenderer } from '@/components_deprecated'
import { cn } from '@/lib/utils'

interface Props {
  oldRaw: unknown
  newRaw: unknown
  oldText: string
  newText: string
  oldLabel: string
  newLabel: string
}

export function LogTabs({
  oldRaw,
  newRaw,
  oldText,
  newText,
  oldLabel,
  newLabel,
}: Props) {
  const [activeTab, setActiveTab] = useState<'new' | 'old'>('new')

  const oldDelta = tryBuildQuillDelta(oldRaw)
  const newDelta = tryBuildQuillDelta(newRaw)

  const showNew = activeTab === 'new'
  const activeDelta = showNew ? newDelta : oldDelta
  const activeText = showNew ? newText : oldText

  return (
    <div className="mt-2 overflow-hidden rounded-md border border-stone-200 bg-white">
      <div className="flex gap-1 border-b border-stone-200 bg-stone-50 p-1">
        <button
          type="button"
          onClick={() => setActiveTab('new')}
          className={cn(
            'rounded px-2 py-1 text-xs font-semibold',
            showNew ? 'bg-white text-stone-900 shadow-sm' : 'text-stone-600'
          )}
        >
          {newLabel}
        </button>

        <button
          type="button"
          onClick={() => setActiveTab('old')}
          className={cn(
            'rounded px-2 py-1 text-xs font-semibold',
            !showNew ? 'bg-white text-stone-900 shadow-sm' : 'text-stone-600'
          )}
        >
          {oldLabel}
        </button>
      </div>

      <div className="px-3 py-2">
        {activeDelta ? (
          <QuillRenderer key={activeTab} contents={activeDelta} />
        ) : (
          <p className="text-sm text-stone-700 whitespace-pre-wrap">
            {activeText || '-'}
          </p>
        )}
      </div>
    </div>
  )
}
